(function(angular){
    'use strict';

    angular.module('app').component('apPrintablePracticeInfo', {
        templateUrl: '/app/views/components/apPrintablePracticeInfo.html',
        controllerAs: 'vm',
        controller: [
            'ContentAttributeService',
            ApPrintablePracticeInfo,
        ],
    });

    function ApPrintablePracticeInfo(
        ContentAttributeService
    ) {
        var vm = this;


        activate();

        function activate() {
            ContentAttributeService
                .getPracticeName(false)
                .then(function(data) {
                    vm.practiceName = data;
                });
        }
    }

})(window.angular);